export const NODE_ENV = import.meta.env.VITE_NODE_ENV;
// API
// ----------------------------------------------------------------------

export const HOST_API = import.meta.env.VITE_HOST_API;
// API base url needs to have a slash at the end
export const DEV_BO_API = import.meta.env.VITE_DEV_BO_API;

export const ASSETS_API = import.meta.env.VITE_ASSETS_API;

export const AC_AUTHORITY = import.meta.env.VITE_AC_AUTHORITY_URL;
export const AC_AUTHORITY_CLIENT_SECRET = import.meta.env.VITE_AC_AUTHORITY_CLIENT_SECRET;
export const OAUTH_REDIRECT_URL = import.meta.env.VITE_OAUTH_REDIRECT_URL;

export const PATH_AFTER_REGISTER = '/auth/jwt/login';

// SENTRY
export const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT;
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

// SYSTEM MESSAGE
export const BANNER_SYSTEM_MESSAGE = import.meta.env.VITE_BANNER_SYSTEM_MESSAGE;

export const CALLBACK_URL = encodeURI(`${window.location.origin}/auth/jwt/callback`);
export const POSTLOGOUT_URL = encodeURI(`${window.location.origin}/`);

// SUPERSET

export const SUPERSET_DOMAIN = import.meta.env.VITE_SUPERSET_DOMAIN;
export const SUPERSET_MAIN_DASHBOARD_ID = import.meta.env.VITE_SUPERSET_DASHBOARD_ID;
export const SUPERSET_ENTEGRA_DASHBOARD_ID = import.meta.env.VITE_SUPERSET_ENTEGRA_DASHBOARD_ID;
export const SUPERSET_INVOICE_DASHBOARD_ID = import.meta.env.VITE_SUPERSET_INVOICE_DASHBOARD_ID;